import { Component, Input } from '@angular/core';
import { DashboardService } from 'src/app/services/dashboard.service';
import { LoaderService } from 'src/app/services/loader.service';
import { PolicyService } from 'src/app/services/policy.service';
import swal from 'sweetalert2';
@Component({
  selector: 'app-dashboard-customer-panel',
  templateUrl: './dashboard-customer-panel.component.html',
  styleUrls: ['./dashboard-customer-panel.component.css']
})
export class DashboardCustomerPanelComponent {
  @Input() totalLeads:number = 0;
  @Input() succeedLeads:number = 0;
  @Input() failedLeads:number = 0;
  @Input() pendingLeads:number = 0;
  @Input() customerReminderList:any=[];


  showPolicyDetails:boolean = false;
  policyDetails:any;
  customerLeadsCardList:any = [];
  constructor(private policyService:PolicyService, private spinner: LoaderService, private dashboardSevice:DashboardService){
    this.getExpiringPolicies();
  }

  async getLeadsStatusCustomerDashboard(StartDate:string,EndDate:string){
    this.totalLeads = 0;
    this.succeedLeads = 0;
    this.failedLeads = 0;
    this.pendingLeads = 0;
    let obj={      
      StartDate:StartDate,//moment(this.selectedStartDate).format('YYYY-MM-DD'),
      EndDate:EndDate//moment(this.selectedEndDate).format('YYYY-MM-DD')
    }

    this.dashboardSevice.GetLeadsStatusCustomerDashboard(obj).then((response)=> { 
      if(response?.isSuccess && response?.result?.length > 30)
      {
        let obj = JSON.parse(response.result);
        if(obj?.length > 0)
        {
          this.totalLeads = obj[0].TotalLeads;
          this.succeedLeads = obj[0].SucceedLeads;
          this.failedLeads = obj[0].FailedLeads;
          this.pendingLeads = obj[0].PendingLeads;
        }
      }
    });
  } 

  async getCustomerLeadsCardDashboard(StartDate:string,EndDate:string){
    this.customerLeadsCardList = [];
    let obj={      
      StartDate:StartDate,//moment(this.selectedStartDate).format('YYYY-MM-DD'),
      EndDate:EndDate//moment(this.selectedEndDate).format('YYYY-MM-DD')
    }

    this.dashboardSevice.GetCustomerLeadsCardDashboard(obj).then((response)=> { 
      if(response?.isSuccess && response?.result?.length > 30)
      {
        let obj = JSON.parse(response.result);
        if(obj?.length > 0)
        {
          this.customerLeadsCardList = obj;
        }
      }
    });
  }

  async getExpiringPolicies(isAgent = false){
    let obj = {
      "agentId": "",
      "isAgent": isAgent,
      "expiringInDays": 30
    }

    this.dashboardSevice.GetExpiringPolicies(obj).then((response)=> { 
      if(response?.isSuccess && response?.result?.length > 0)
      {
        this.customerReminderList = response?.result
      }
      else
      {
        this.customerReminderList = [];
      }
    });
  } 

  async getPolicyDetails(pId:any, expiringIn:any){
    this.spinner.show();
    this.showPolicyDetails = true;
    this.policyService.PolicyDetailsById1(pId,"","","").then((response)=> { 
      this.spinner.hide();
      if(response?.isSuccess && response?.result)
      {
        this.policyDetails = response?.result;
        if(this.policyDetails){
          this.policyDetails.quoteId = 'Policy expiring ' + (expiringIn == 0 ? 'today' : (expiringIn > 1 ? (' in ' + expiringIn +' days') : (' in ' + expiringIn +' day')));
        }
        //this.customerReminderList = response?.result
      }
      else
      {
        alert(JSON.stringify(response??""))
      }
    });
  }

  async DownloadPolicy() {  
      this.spinner.show();
      const response = await this.policyService.DownloadPolicy(this.policyDetails.policyIdEnc);
      if (response?.isSuccess && response.result && response.result.code ==1)
      {
        const downloadLink = document.createElement('a');
        downloadLink.href = response.result.data;
        if(response.result.data2 != null && response.result.data2 != undefined && response.result.data2 != ""){
          downloadLink.download = response.result.data2;
        }      
        downloadLink.target = "_blank"; 
        downloadLink.click();
        this.spinner.hide();
      }
      else
      {
        this.spinner.hide();
        swal.fire({
          position: 'center',
          imageUrl: "../../assets/alerts/warning.png",
          imageHeight: 89,
          title: "Policy document is not generated yet, please try after some time.",
          showCancelButton: true,
          showConfirmButton: false,
          cancelButtonText: 'Ok',
          cancelButtonColor: "#DF3A4D",
        }); 
      }
    }

}
